import React from "react";

function AnswerDetailPage() {
  return <div>Answer Detail Page</div>;
}

export default AnswerDetailPage;
